import { Component, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LineDetailsService } from '../../../services/line-details.service';
import { AccountLinesSummaryDTO } from 'src/app/data/models/account-lines-summary';
import { DeviceStatusEnum } from 'src/app/data/enums/device-status-enum';

@Component({
  selector: 'app-ll-total-summary',
  templateUrl: './ll-total-summary.component.html',
  styleUrls: ['./ll-total-summary.component.scss'],
  providers: [MessageService]
})
export class LlTotalSummaryComponent {
  downLines: number = 0;
  upLines: number = 0;
  parentDownLines: number = 0;
  maintenanceLines: number = 0;
  totalLines: number = 0;
  ticketsNumber: number = 0;
  totalUnmonitoredLines: number = 0;
  loading: boolean = false;
  @ViewChild('op') linesPanel: OverlayPanel;
  selectedDeviceIp: any;
  linesListTitle: string;

  constructor(private messageService: MessageService, private lineDetailsService: LineDetailsService) { }

  ngOnInit(): void {
    this.getLeasedLinesMonitoringSummary();
  }

  getLeasedLinesMonitoringSummary() {
    this.loading = true;
    this.lineDetailsService.getLeasedLinesMonitoringSummary().subscribe(
      (response: AccountLinesSummaryDTO) => {
        this.loading = false;
        this.totalLines = response.totalLines;
        this.upLines = response.totalUplines;
        this.ticketsNumber = response.totalTickets;
        this.totalUnmonitoredLines = response.totalUnmonitoredLines;
        this.downLines = response.totalDownlines;
        this.maintenanceLines = response.totalMntncLines;
        
      },
      () => {
        this.loading = false;
      }
    );
  }

}
